export const month_options = [
  {
    name: '01',
    value: '01',
  },
  {
    name: '02',
    value: '02',
  },
  {
    name: '03',
    value: '03',
  },
  {
    name: '04',
    value: '04',
  },
  {
    name: '05',
    value: '05',
  },
  {
    name: '06',
    value: '06',
  },
  {
    name: '07',
    value: '07',
  },
  {
    name: '08',
    value: '08',
  },
  {
    name: '09',
    value: '09',
  },
  {
    name: '10',
    value: '10',
  },
  {
    name: '11',
    value: '11',
  },
  {
    name: '12',
    value: '12',
  },
];



// WEBPACK FOOTER //
// ./src/utils/creditCard.js